import { Provider } from "@angular/core";
import { environment } from 'src/environments/environment';
import { CpxHandleMockService } from "../cpx-handle/cpx-handle-mock.service";
import { CpxHandleService } from "../cpx-handle/cpx-handle.service";
import { CpxApiErrorService } from "../cpx-handle/cpx-api-error.service";
import { CpxHandleServiceAbstract } from './cpx-handle-service-abstract';
import { RessourceService } from "../ressource/ressource.service";
import { ModalService } from "../modal/modal.service";
import { SnackbarService } from "../snackbar/snackbar.service";
import { LoginService } from "../login/login.service";
import { UserService } from "../user/user.service";
import { StringUtilsService } from "../string-utils/string-utils.service";
import { ReferentielService } from "../referentiel/referentiel.service";
import { LogFonctionnelService } from "../log-fonctionnel/log-fonctionnel.service";
import { SessionService } from "./connecteur-dinno/models";
import { FeatureService } from "../feature/feature.service";
import { StellairService } from "../stellair/stellair.service";
import { EdcAuthService } from "../auth/edc-auth.service";
import { ProfilService } from "../profil/profil.service";

const cpxHandleServiceFactory = (
  resourceSrv: RessourceService,
  modalService: ModalService,
  snackbarService: SnackbarService,
  userSrv: UserService,
  refSrv: ReferentielService,
  strUtilsSrv: StringUtilsService,
  logSrv: LogFonctionnelService,
  dinnoSessionSrv: SessionService,
  featureSrv: FeatureService,
  stellairSrv: StellairService,
  edcAuthSrv: EdcAuthService,
  profilSrv: ProfilService
) => {
  if (environment.cpxMock) {
    return new CpxHandleMockService();
  } else {
    return new CpxHandleService(new CpxApiErrorService(), resourceSrv, modalService,
      snackbarService, userSrv, refSrv, strUtilsSrv, logSrv, dinnoSessionSrv, featureSrv,
      stellairSrv, edcAuthSrv, profilSrv);
  }
};

export const cpxHandleServiceProvider: Provider = {
  provide: CpxHandleServiceAbstract,
  useFactory: cpxHandleServiceFactory,
  deps: [
    RessourceService,
    ModalService,
    SnackbarService,
    UserService,
    ReferentielService,
    StringUtilsService,
    LogFonctionnelService,
    SessionService,
    FeatureService,
    StellairService,
    EdcAuthService,
    ProfilService
  ]
};
